import {useContext} from 'react'
import {CustomerReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {CUSTOMER_TYPE_REPORT_COLUMNS} from '../../utils'
import CustomerTypeRow from './CustomerTypeRow'
import {parseCustomerTypeReportRow} from '../../parsings'
import {formatPrice} from '../../../../utils/common'
import CustomerGroupTypeTableReportHeader from '../header/CustomerGroupTypeTableReportHeader'

const CustomerTypeTable = () => {
  const {
    customerTypeData,
    isCustomerTypeLoading,
    customerTypeReportFilters,
    onSortingChangeCustomerTypeReport,
  } = useContext(CustomerReportContext)

  return (
    <div className='card border mb-10'>
      <div className='card-body p-7'>
        <CustomerGroupTypeTableReportHeader />
        <DynamicTable
          data={customerTypeData}
          sortableColumns={CUSTOMER_TYPE_REPORT_COLUMNS}
          loading={isCustomerTypeLoading}
          TableRow={CustomerTypeRow}
          noDataMessage='No customer types found'
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          rowParsingFunction={parseCustomerTypeReportRow}
          filters={customerTypeReportFilters}
          onSortingChange={onSortingChangeCustomerTypeReport}
          tableFooter={({columnTotals}: any) => (
            <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
              <tr>
                <td>TOTAL</td>
                <td>{columnTotals?.total_orders}</td>
                <td>{formatPrice(columnTotals.total_cost, false)}</td>
                <td>{formatPrice(columnTotals.total_sales, false)}</td>
                <td>{formatPrice(columnTotals.total_profit, false)}</td>
              </tr>
            </tfoot>
          )}
        />
      </div>
    </div>
  )
}

export default CustomerTypeTable
